import { render, staticRenderFns } from "./OilPrice.vue?vue&type=template&id=1c98251a&scoped=true&"
import script from "./OilPrice.vue?vue&type=script&lang=js&"
export * from "./OilPrice.vue?vue&type=script&lang=js&"
import style0 from "./OilPrice.vue?vue&type=style&index=0&id=1c98251a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98251a",
  null
  
)

export default component.exports